export const GuideOutline = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask
            id="mask0_2019_44469"
            // style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="3"
            y="2"
            width="18"
            height="21"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 2H20.0388V22.8467H3V2Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask0_2019_44469)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.34179 3.5C5.79279 3.5 4.49979 4.482 4.49979 6.421V21.145C4.49979 21.239 4.55379 21.29 4.59879 21.316C4.64379 21.344 4.71479 21.364 4.79679 21.318L11.1788 17.738C11.4068 17.611 11.6858 17.61 11.9148 17.739L18.2418 21.313C18.3248 21.361 18.3958 21.339 18.4408 21.312C18.4858 21.285 18.5388 21.234 18.5388 21.14V6.604C18.5388 5.837 18.5388 3.5 14.7008 3.5H8.34179ZM4.69879 22.847C4.40379 22.847 4.10879 22.768 3.84079 22.61C3.31379 22.303 2.99979 21.754 2.99979 21.145V6.421C2.99979 3.611 4.94679 2 8.34179 2H14.7008C18.0928 2 20.0388 3.679 20.0388 6.604V21.14C20.0388 21.75 19.7248 22.299 19.1968 22.606C18.6708 22.914 18.0368 22.92 17.5048 22.62L11.5448 19.253L5.52979 22.627C5.26979 22.773 4.98479 22.847 4.69879 22.847Z"
                fill="#A5A5A5"
            />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.1396 10.2285H7.82159C7.40759 10.2285 7.07159 9.89252 7.07159 9.47852C7.07159 9.06452 7.40759 8.72852 7.82159 8.72852H15.1396C15.5536 8.72852 15.8896 9.06452 15.8896 9.47852C15.8896 9.89252 15.5536 10.2285 15.1396 10.2285Z"
            fill="#A5A5A5"
        />
    </svg>
);
